import { useEventCallback } from '@mui/material';
import { Form, Formik } from 'formik';
import { Fragment, ReactElement, useEffect, useState } from 'react';
import FilterPractice from './filter-practice';
import FilterPerson from './filter-person';
import { validationSchemaFilterPractice } from 'practice/constants/practice-research-validation';
import { FilterPracticeVM, FilterPersonVM } from 'practice/view-models/practice-research';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import {
  PracticeSearchType,
  initialValuesPraticeSearch,
  PracticeFilterSearchType,
} from 'practice/pages/storage-practice';

export const defaultInitialValuesPractice: FilterPracticeVM = Object.freeze({
  typeRegister: undefined,
  fromNumber: undefined,
  atNumber: undefined,
  dateFrom: null,
  years: undefined,
});

interface FilterProps {
  initialValuesPractice?: FilterPracticeVM;
  initialValuesFilterPerson?: FilterPersonVM;
  practiceLength: number;
  authPerson?: string;
  userOperator?: string;
  onSubmitFilterPractice: (values: FilterPracticeVM) => void;
  onSubmitPerson: (person: FilterPersonVM, operatorCode?: string) => void;
  withResponse?: boolean;
  isResearch?: boolean;
}

const Filter = ({
  initialValuesPractice = initialValuesPraticeSearch,
  initialValuesFilterPerson,
  authPerson,
  onSubmitFilterPractice,
  onSubmitPerson,
  withResponse = false,
  isResearch,
}: FilterProps): ReactElement => {
  useEffect(() => {
    // se la ricerca genera risultato chiudera gli accordion
    if (withResponse) {
      setOpenPractice(false);
      setOpenPerson(false);
    }
  }, [withResponse]);

  const filterTable = useFilterTable<PracticeSearchType>();

  useEffect(() => {
    if (
      filterTable?.values?.isChildComponentVisited &&
      filterTable?.values?.searchType === PracticeFilterSearchType.SEARCH_BY_PERSON
    ) {
      const personFilterData: FilterPersonVM = {
        birthChoiceDate: filterTable?.values?.birthChoiceDate,
        birthDate: filterTable?.values?.birthDate,
        fiscalCode: filterTable?.values?.fiscalCode,
        foreignState: filterTable?.values?.foreignState,
        gender: filterTable?.values?.gender,
        isForeign: filterTable?.values?.isForeign,
        municipality: filterTable?.values?.municipality,
        name: filterTable?.values?.name,
        surname: filterTable?.values?.surname,
        withoutName: filterTable?.values?.withoutName,
        withoutSurname: filterTable?.values?.withoutSurname,
      };

      onSubmitPerson(personFilterData);
    }
  }, []);

  const onSubmitFilterPerson = useEventCallback((values: FilterPersonVM) => {
    // ricerca persona
    onSubmitPerson(values);
  });

  const [openPractice, setOpenPractice] = useState<boolean>(true);
  const [openPerson, setOpenPerson] = useState<boolean>(true);

  return (
    <Fragment>
      <Formik
        validationSchema={validationSchemaFilterPractice}
        initialValues={{
          ...(initialValuesPractice || {}),
          onlyPracticeAssigned: authPerson === '0',
        }}
        onSubmit={(values) => {
          filterTable?.setValues({
            ...filterTable.values,
            searchType: PracticeFilterSearchType.SEARCH_BY_PRATICE,
          });
          onSubmitFilterPractice({
            ...values,
          });

          setOpenPerson(false);
        }}
        enableReinitialize
      >
        <Form>
          <FilterPractice
            open={openPractice}
            setOpen={setOpenPractice}
            authPerson={authPerson}
            isResearch={isResearch}
          />
        </Form>
      </Formik>

      <Formik
        initialValues={initialValuesFilterPerson || {}}
        onSubmit={(values) => {
          setOpenPerson(false);

          onSubmitFilterPerson(values);
        }}
      >
        <Form>
          <FilterPerson open={openPerson} setOpen={setOpenPerson} />
        </Form>
      </Formik>
    </Fragment>
  );
};

Filter.displayName = 'Filter shared';

export default Filter;
